import { render } from "./UtilityBar.vue?vue&type=template&id=45ef0b45&scoped=true"
import script from "./UtilityBar.vue?vue&type=script&lang=js"
export * from "./UtilityBar.vue?vue&type=script&lang=js"

import "./UtilityBar.vue?vue&type=style&index=0&id=45ef0b45&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ef0b45"]])

export default __exports__